import { api } from '../../_generated/api/assets-api.generated';

export const locksApi = api.enhanceEndpoints({
  addTagTypes: ['Lock'],
  endpoints: {
    ReadLock: {
      providesTags: (_, __, args) => [
        { type: 'Lock' as const, id: `${args.assetType}:${args.assetId}` },
      ],
    },
    CreateLock: {
      invalidatesTags: (_, __, { lock }) => [
        {
          type: 'Lock' as const,
          id: `${lock.resourceType}:${lock.resourceId}`,
        },
      ],
    },
    DeleteLock: {
      invalidatesTags: (_, __, args) => [
        { type: 'Lock' as const, id: `${args.assetType}:${args.assetId}` },
      ],
    },
  },
});

export const {
  useReadLockQuery,
  useCreateLockMutation,
  useDeleteLockMutation,
} = locksApi;
